import Button from '@/components/Button'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import {
  setCountryPreferenceGlobal,
  setCountryPreferenceIndiaAndRedirect,
  UserCountryPrefernceCookieName,
  UserCountryPrefernceCookieValues,
} from '@/lib/countryPreference'
import Modal from '@/widgets/Modal'
import { getCookie } from 'cookies-next'
import { useEffect, useState } from 'react'

const CountryPreferenceModal = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const userCountryPrefernceCookie = getCookie(UserCountryPrefernceCookieName)
    if (userCountryPrefernceCookie && userCountryPrefernceCookie === UserCountryPrefernceCookieValues.UNKNOWN) {
      setIsOpen(true)
    }
  }, [])

  return (
    <Modal isOpen={isOpen} onDismiss={() => setIsOpen(false)} isClosable={true}>
      <Layout spacing="lg" className="text-center p-8">
        <Stack y>
          <img
            src="/images/india-flag.svg"
            alt="India Flag"
            className="w-1/2 h-1/2 object-cover mx-auto block rounded-md"
          />
          <Text size="xl" className="mb-md text-lg md:text-xl lg:text-2xl">
            Are you in India?
          </Text>
          <div className="w-full max-w-xs mx-auto">
            <Stack y spaceBetweenY="sm" justifyContent="center" alignItems="center">
              <Button
                label="Visit our India Website"
                theme="primary"
                onClick={setCountryPreferenceIndiaAndRedirect}
                className="w-full"
              />
              <Button
                label="Continue on Global Website"
                theme="secondaryOutline"
                onClick={() => {
                  setCountryPreferenceGlobal()
                  setIsOpen(false)
                }}
                className="w-full"
              />
            </Stack>
          </div>
        </Stack>
      </Layout>
    </Modal>
  )
}

export default CountryPreferenceModal
